import styled from "styled-components";

export const ModalContainer = styled.div`
  width: 90%;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.5);
  overflow: hidden;
  max-height: 90dvh;
  overflow-y: auto;
  max-width: 400px;
  border-radius: 24px;
  border: 1px solid #18181b;
  background: #0a0b0c;
  position: relative;
  z-index: 1000;
`;

export const ModalTitle = styled.h2`
  color: #fff;
  font-family: Figtree;
  font-size: 18px;
  font-weight: 600;
  letter-spacing: -0.09px;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  position: relative;
`;

export const CloseButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #fff;

  &:hover {
    opacity: 0.7;
  }
`;

export const ModalContent = styled.div`
  padding: 24px 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
  text-align: center;
`;

export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 8px;
`;

export const Label = styled.p`
  color: #fff;
  text-align: left;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 500;
  line-height: -0.21px;
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 12px;
  justify-content: space-between;
  width: 100%;
`;

export const FolderListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  overflow-y: auto;
  max-height: 286px;
  padding-right: ${(p) => (p.$paddingRight ? "0px" : "8px")};

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: #18181b;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: #3d3d45;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #52525b;
  }
`;

export const FolderItem = styled.div`
  display: flex;
  width: 100%;
  min-height: 41px;
  padding: 12px;
  align-items: center;
  gap: 10px;
  border-radius: 12px;
  border: 0.5px solid #3d3d45;
  background: #18181b;
  cursor: pointer;
  transition: all 0.2s ease;
  justify-content: space-between;

  &:hover {
    background: ${({ $isSelected }) => ($isSelected ? "#18181b" : "#1e1e21")};
  }

  svg {
    flex-shrink: 0;
    color: ${({ $isSelected }) => ($isSelected ? "#2877d9" : "#fff")};
  }
`;

export const FolderName = styled.span`
  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.21px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const CancelButton = styled.button`
  display: flex;
  width: 110px;
  height: 40px;
  padding: 0 20px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 100px;
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.2);
  outline: none;

  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.21px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover:not(:disabled) {
    background: rgba(255, 255, 255, 0.05);
    border-color: rgba(255, 255, 255, 0.4);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const ConfirmButton = styled.button`
  display: flex;
  min-width: 110px;
  height: 40px;
  padding: 0 20px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 100px;
  background: ${({ $type }) => {
    switch ($type) {
      case "danger":
        return "linear-gradient(135deg, #ff4757, #ff3838)";
      case "success":
        return "linear-gradient(135deg, #2877D9, #c4057a)";
      case "primary":
      default:
        return "#fff";
    }
  }};
  border: none;
  outline: none;

  color: ${({ $type }) => ($type === "primary" ? "#09090b" : "#ffffff")};
  font-family: Figtree;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.21px;
  white-space: nowrap;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: ${({ $type }) => {
      switch ($type) {
        case "danger":
          return "0 4px 15px rgba(255, 71, 87, 0.3)";
        case "success":
          return "0 4px 15px rgba(163, 0, 94, 0.3)";
        case "primary":
        default:
          return "0 4px 15px rgba(0, 0, 0, 0.1)";
      }
    }};
  }

  &:active:not(:disabled) {
    transform: translateY(0);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    pointer-events: none;
  }
`;

export const Input = styled.input`
  display: flex;
  padding: 12px;
  align-items: flex-start;
  gap: 10px;
  align-self: stretch;
  border-radius: 12px;
  border: 0.5px solid #3d3d45;
  background: #18181b;

  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: -0.21px;
`;
